import _map from 'lodash/map';
import _zipObject from 'lodash/zipObject';

import {
  ERROR_INTEGRATION_SETTINGS,
  ERROR_INTEGRATION_SUGGESTION,
  RESET_INTEGRATION_SUGGESTION,
  SAVING_INTEGRATION_SETTINGS,
  SAVING_INTEGRATION_SUGGESTION,
  SUCCESS_INTEGRATION_SETTINGS,
  SUCCESS_INTEGRATION_SUGGESTION,
  UPDATE_COMPANY_RESULTS,
  UPDATE_INTEGRATION_SETTINGS,
} from 'constants/actions';
import { ALL, ENABLED, EXPAND } from 'constants/integrationSettings';
import {
  ADDITIONAL_INFO,
  DOMAIN,
  NAME,
} from 'constants/integrationSuggestionsFields';

const defaultIntegrateObject = {
  [ENABLED]: true,
  [EXPAND]: true,
};

const defaultIntegrationSettings = _zipObject(
  ALL,
  _map(ALL, () => defaultIntegrateObject)
);

export const DEFAULT_SUGGESTION = {
  [ADDITIONAL_INFO]: '',
  [DOMAIN]: '',
  [NAME]: '',
};

const DEFAULT_INTEGRATION_SETTINGS_STATE = {
  settings: defaultIntegrationSettings,
  settings_fetching: false,
  settings_success: false,
  settings_error: null,
  suggestion_fetching: false,
  suggestion_success: false,
  suggestion_error: null,
  company_results: null,
};

const integrationReducer = (
  state = DEFAULT_INTEGRATION_SETTINGS_STATE,
  action
) => {
  switch (action.type) {
    case UPDATE_INTEGRATION_SETTINGS: {
      const settings = Object.assign(
        {},
        state.settings,
        action.integrationSettings
      );

      return Object.assign({}, state, { settings });
    }
    case SAVING_INTEGRATION_SETTINGS:
      return {
        ...state,
        settings_fetching: true,
        settings_success: false,
      };
    case SUCCESS_INTEGRATION_SETTINGS:
      return {
        ...state,
        settings_fetching: false,
        settings_success: true,
        settings_error: null,
      };
    case ERROR_INTEGRATION_SETTINGS:
      return {
        ...state,
        settings_fetching: false,
        settings_success: false,
        settings_error: action.errorMessage,
      };
    case SAVING_INTEGRATION_SUGGESTION:
      return {
        ...state,
        suggestion_fetching: true,
        suggestion_success: false,
      };
    case SUCCESS_INTEGRATION_SUGGESTION:
      return {
        ...state,
        suggestion_fetching: false,
        suggestion_success: true,
        suggestion_error: null,
      };
    case ERROR_INTEGRATION_SUGGESTION:
      return {
        ...state,
        suggestion_fetching: false,
        suggestion_success: false,
        suggestion_error: action.errorMessage,
      };
    case RESET_INTEGRATION_SUGGESTION:
      return {
        ...state,
        suggestion_fetching: false,
        suggestion_success: false,
        suggestion_error: null,
      };
    case UPDATE_COMPANY_RESULTS:
      return {
        ...state,
        company_results: action.results,
      };
    default:
      return state;
  }
};

export default integrationReducer;
